var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29 14H15V0h-1v14H0v1h14v14h1V15h14v-1z"
  })));
};

export { SvgPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDI5IDI5Ij48dGl0bGU+cGx1czE8L3RpdGxlPjxwb2x5Z29uIHBvaW50cz0iMjkgMTQgMTUgMTQgMTUgMCAxNCAwIDE0IDE0IDAgMTQgMCAxNSAxNCAxNSAxNCAyOSAxNSAyOSAxNSAxNSAyOSAxNSAyOSAxNCIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==";